import { useFetchNotesQuery } from '../notesApi';

export const useNotes = () => {
  return useFetchNotesQuery(undefined, {
    selectFromResult: ({ data, isLoading, isError, error }) => ({
      notesData: data || [],
      isLoading,
      isError,
      error,
    }),
  });
};
